import { type StepContextValue } from '../contexts/step-provider'
import { useSidePanelHasBeenOpenedContext } from '../contexts/use-side-panel-has-been-opened-context'
import { useStepContext } from '../contexts/use-step-context'

/**
 * Hook to access the current step state and setter function from step context.
 * Must be used within a StepProvider component tree.
 *
 * @returns Object containing the current step and setStep function
 * @throws Error if used outside of StepProvider
 */
export const useStep = (): StepContextValue & { isLockedToGoTime: boolean } => {
  const context = useStepContext()
  const sidePanelHasBeenOpened = useSidePanelHasBeenOpenedContext()

  return { ...context, isLockedToGoTime: sidePanelHasBeenOpened }
}
